module.exports = __webpack_public_path__ + "img/manageChannel-active.2ada018c.svg";